import { render, staticRenderFns } from "./NewLesson.vue?vue&type=template&id=8aab5934&"
import script from "./NewLesson.vue?vue&type=script&lang=js&"
export * from "./NewLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports